exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sk-three-bounce {\n    top: 50%;\n    position: relative;\n    margin: auto;\n    width: 80px;\n    text-align: center;\n}\n\n.sk-three-bounce .sk-child {\n    width: 20px;\n    height: 20px;\n    border-radius: 100%;\n    display: inline-block;\n    animation: sk-three-bounce 1.4s ease-in-out 0s infinite both;\n}\n\n.sk-three-bounce .sk-bounce1 {\n    animation-delay: -0.32s;\n}\n\n.sk-three-bounce .sk-bounce2 {\n    animation-delay: -0.16s;\n}\n\n@keyframes sk-three-bounce {\n    0%, 80%, 100% {\n        transform: scale(0);\n    }\n    40% {\n        transform: scale(1);\n    }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /builds/yaratechnologies/talkative-parents-portal/src/app/spinner/spinkit-css/sk-three-bounce.css
// module id = ../../../../../src/app/spinner/spinkit-css/sk-three-bounce.css
// module chunks = main